// Logger applicativo nominato, null-safe. Specchio di `CloseYourIt.logger`
// (gem, LogDevice) e `CloseYourItLogger` (dart): metodi di comodo per livello
// che delegano a `client.log`. `warn` viene normalizzato in `warning` (canone
// wire). Prima di `init` ogni metodo è no-op.

import type { Client } from './client'

export class CloseYourItLogger {
  constructor(
    private readonly getClient: () => Client | null,
    private readonly name?: string | undefined,
  ) {}

  /// Un logger figlio con nome (`logger.named('payments').info(...)`).
  named(name: string): CloseYourItLogger {
    return new CloseYourItLogger(this.getClient, name)
  }

  debug(message: string, attributes?: Record<string, unknown>): void {
    this.emit('debug', message, attributes)
  }

  info(message: string, attributes?: Record<string, unknown>): void {
    this.emit('info', message, attributes)
  }

  warn(message: string, attributes?: Record<string, unknown>): void {
    this.emit('warning', message, attributes)
  }

  error(message: string, attributes?: Record<string, unknown>): void {
    this.emit('error', message, attributes)
  }

  fatal(message: string, attributes?: Record<string, unknown>): void {
    this.emit('fatal', message, attributes)
  }

  private emit(
    level: 'debug' | 'info' | 'warning' | 'error' | 'fatal',
    message: string,
    attributes?: Record<string, unknown>,
  ): void {
    this.getClient()?.log(level, message, attributes, this.name)
  }
}
